import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {FileReference} from '../../class/file-reference';
import {ApiService} from '../../service/api.service';
import {NbContextMenuDirective, NbMenuItem} from '@nebular/theme';
import {UPLOAD_KIND} from '../../class/file/upload-kind.enum';

@Component({
  selector: 'app-attachments',
  templateUrl: './attachments.component.html',
  styleUrls: ['./attachments.component.css']
})
export class AttachmentsComponent implements OnInit {

  @ViewChild(NbContextMenuDirective) contextMenu: NbContextMenuDirective;

  items: NbMenuItem[] = [
    {title: 'Scarica', icon: ''},
    {title: 'Elimina', icon: ''},
  ];

  files: FileReference[];

  @Input()
  objectID: string;

  @Input()
  fileReferenceKind: UPLOAD_KIND;

  @Output()
  onFileRemoved = new EventEmitter<FileReference>();

  constructor(private apiService: ApiService) {
  }

  ngOnInit() {
    this.loadAttachments();
  }

  loadAttachments() {
    this.apiService.getFileReferences(this.objectID, this.fileReferenceKind).subscribe(value => {
      this.files = value;
    });
  }

  downloadAttachment(fileReference: FileReference) {
    this.apiService.downloadRequest(fileReference).subscribe(value => {
    });
  }

  deleteAttachment(fileReference: FileReference) {
    this.apiService.deleteFileReference(fileReference).subscribe(value => {
        if (value) {
          // remove from attachments
          this.files.forEach((value1, index) => {
            if (value1.fileName === value.fileName) {
              this.files.splice(index, 1);
              this.onFileRemoved.emit(value);
            }
          });
        }
      }
    );
  }
}
